import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelSlovak: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'B',
    meta: [
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 6,
    label: 'C',
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: 'Đ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
    meta: [
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: 'G',
    meta: [
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 11,
    label: 'H',
  },
  {
    code: 12,
    label: 'I',
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
    meta: [
      {
        label: 'ł',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: 'Ł',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: "'",
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'Q',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'đ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
  },
  {
    code: 24,
    label: 'U',
  },
  {
    code: 25,
    label: 'V',
    meta: [
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 26,
    label: 'W',
    meta: [
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
    meta: [
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'Z',
  },
  {
    code: 29,
    label: 'Y',
    meta: [
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '+',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: 'ľ',
    meta: [
      {
        label: '^ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: 'š',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˘ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: 'č',
    meta: [
      {
        label: '° (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: 'ť',
    meta: [
      {
        label: '˛ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: 'ž',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '`',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: 'ý',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˙ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: 'á',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 38,
    label: 'í',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: 'é',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '=',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '´ (dead)',
    meta: [
      {
        label: 'ˇ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: 'ˇ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¸ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'ú',
    meta: [
      {
        label: '/',
        modifiers: MOD.SFT,
      },
      {
        label: '/',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: 'ä',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: 'ň',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¤',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'ô',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: '§',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: ';',
    meta: [
      {
        label: '° (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '° (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 56,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 100,
    label: '&',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 512,
    label: '2',
  },
  {
    code: 512,
    label: '5',
  },
  {
    code: 542,
    label: '1',
  },
  {
    code: 544,
    label: '3',
  },
  {
    code: 545,
    label: '4',
  },
  {
    code: 547,
    label: '6',
  },
  {
    code: 548,
    label: '7',
  },
  {
    code: 549,
    label: '8',
  },
  {
    code: 550,
    label: '9',
  },
  {
    code: 551,
    label: '0',
  },
  {
    code: 557,
    label: '%',
  },
  {
    code: 558,
    label: 'ˇ (dead)',
  },
  {
    code: 559,
    label: '/',
  },
  {
    code: 560,
    label: '(',
  },
  {
    code: 562,
    label: ')',
  },
  {
    code: 563,
    label: '"',
  },
  {
    code: 564,
    label: '!',
  },
  {
    code: 565,
    label: '° (dead)',
  },
  {
    code: 566,
    label: '?',
  },
  {
    code: 567,
    label: ':',
  },
  {
    code: 568,
    label: '_',
  },
  {
    code: 612,
    label: '*',
  },
  {
    code: 4608,
    label: '2',
  },
  {
    code: 4608,
    label: '5',
  },
  {
    code: 4638,
    label: '1',
  },
  {
    code: 4640,
    label: '3',
  },
  {
    code: 4641,
    label: '4',
  },
  {
    code: 4643,
    label: '6',
  },
  {
    code: 4644,
    label: '7',
  },
  {
    code: 4645,
    label: '8',
  },
  {
    code: 4646,
    label: '9',
  },
  {
    code: 4647,
    label: '0',
  },
  {
    code: 4653,
    label: '%',
  },
  {
    code: 4654,
    label: 'ˇ (dead)',
  },
  {
    code: 4655,
    label: '/',
  },
  {
    code: 4656,
    label: '(',
  },
  {
    code: 4658,
    label: ')',
  },
  {
    code: 4659,
    label: '"',
  },
  {
    code: 4660,
    label: '!',
  },
  {
    code: 4661,
    label: '° (dead)',
  },
  {
    code: 4662,
    label: '?',
  },
  {
    code: 4663,
    label: ':',
  },
  {
    code: 4664,
    label: '_',
  },
  {
    code: 4708,
    label: '*',
  },
  {
    code: 5125,
    label: '{',
  },
  {
    code: 5127,
    label: 'Đ',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5129,
    label: '[',
  },
  {
    code: 5130,
    label: ']',
  },
  {
    code: 5134,
    label: 'ł',
  },
  {
    code: 5135,
    label: 'Ł',
  },
  {
    code: 5137,
    label: '}',
  },
  {
    code: 5139,
    label: "'",
  },
  {
    code: 5140,
    label: '(backslash)',
  },
  {
    code: 5142,
    label: 'đ',
  },
  {
    code: 5145,
    label: '@',
  },
  {
    code: 5146,
    label: '|',
  },
  {
    code: 5147,
    label: '#',
  },
  {
    code: 5149,
    label: '>',
  },
  {
    code: 5150,
    label: '~',
  },
  {
    code: 5151,
    label: '^ (dead)',
  },
  {
    code: 5152,
    label: '˘ (dead)',
  },
  {
    code: 5153,
    label: '° (dead)',
  },
  {
    code: 5154,
    label: '˛ (dead)',
  },
  {
    code: 5155,
    label: '`',
  },
  {
    code: 5156,
    label: '˙ (dead)',
  },
  {
    code: 5159,
    label: '˝ (dead)',
  },
  {
    code: 5165,
    label: '¨ (dead)',
  },
  {
    code: 5166,
    label: '¸ (dead)',
  },
  {
    code: 5167,
    label: '÷',
  },
  {
    code: 5168,
    label: '×',
  },
  {
    code: 5170,
    label: '¤',
  },
  {
    code: 5171,
    label: '$',
  },
  {
    code: 5172,
    label: 'ß',
  },
  {
    code: 5220,
    label: '<',
  },
];
